import 'css-chunk:src/components/form-fields/dropdown-component/dropdown-component.module.scss';export default {
  "dropdown-component": "dropdown-component_dropdown-component__6vB8z",
  "white": "dropdown-component_white__KwtNx",
  "option-container": "dropdown-component_option-container__9-7pH",
  "grey": "dropdown-component_grey__k6mX8",
  "info": "dropdown-component_info__ve0eJ",
  "label": "dropdown-component_label__fV9dT",
  "help-text": "dropdown-component_help-text__V-lsF",
  "error-text": "dropdown-component_error-text__WlbGm",
  "invalid": "dropdown-component_invalid__d3Uo8",
  "disabled": "dropdown-component_disabled__hQ-Ie",
  "selected-option": "dropdown-component_selected-option__8SJj5",
  "placeholder": "dropdown-component_placeholder__3hS37",
  "icon": "dropdown-component_icon__XiZw0",
  "search-div": "dropdown-component_search-div__ANXLP",
  "additional-info": "dropdown-component_additional-info__41-10",
  "group-name": "dropdown-component_group-name__Si5-H",
  "dropdown-content": "dropdown-component_dropdown-content__40-hq",
  "dropdown-item": "dropdown-component_dropdown-item__CjHWF",
  "dropdown-item-separator": "dropdown-component_dropdown-item-separator__YDitC",
  "grouped": "dropdown-component_grouped__-s9-H",
  "search-dropdown-wrapper": "dropdown-component_search-dropdown-wrapper__pQqHu",
  "search-dropdown-content": "dropdown-component_search-dropdown-content__sFzPG",
  "dropdown-wrapper": "dropdown-component_dropdown-wrapper__xvVHP",
  "modal": "dropdown-component_modal__mmItQ",
  "search-dropdown-open": "dropdown-component_search-dropdown-open__2v7DB",
  "hide-mobile-svg": "dropdown-component_hide-mobile-svg__0-D5I",
  "show-mobile-svg": "dropdown-component_show-mobile-svg__70zVI",
  "last": "dropdown-component_last__JAJKe",
  "search-modal-grouped": "dropdown-component_search-modal-grouped__aD7N8",
  "search-group-list": "dropdown-component_search-group-list__JAAme",
  "mobile-header": "dropdown-component_mobile-header__DKjAv",
  "scroll-container": "dropdown-component_scroll-container__-iv-A",
  "scroll-container-not-searchable": "dropdown-component_scroll-container-not-searchable__51LDq",
  "overlay": "dropdown-component_overlay__WCEMz",
  "no-scroll": "dropdown-component_no-scroll__E6ZWY"
};